import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "./Header.js";
import useAuth from "./useAuth";
import Sidebar from "./Sidebar.js";
import Footer from "./Footer.js";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Edit_Vehiclenumber() {
    useAuth();
    const navigate = useNavigate();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        vehicle_number: "",
        id: id,
        documents: [],
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchDetails();
    }, [id]);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${API_BASE_URL}getVehicleNumberById/${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });

            const result = await response.json();
            if (result.status) {
                setFormData({
                    vehicle_number: result.data.vehicle_number,
                    id: id,
                    documents: result.data.documents || [],
                });
            } 
        } catch (error) {
            toast.error("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    const validateFormData = () => {
        if (!formData.vehicle_number) {
            toast.error("Vehicle number is required");
            return false;
        }
        for (let doc of formData.documents) {
            if (!doc.type) {
                toast.error("Document type is required");
                return false;
            }
            if (!doc.image) {
                toast.error("Image is required for all document types");
                return false;
            }
        }
        return true;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleDocumentChange = (index, e) => {
        const { name, value, files } = e.target;
        const updatedDocuments = [...formData.documents];
        updatedDocuments[index] = {
            ...updatedDocuments[index],
            [name]: files ? files[0] : value,
        };
        setFormData({ ...formData, documents: updatedDocuments });
    };

    const addRow = () => {
        setFormData((prevState) => ({
            ...prevState,
            documents: [...prevState.documents, { type: "", image: null }],
        }));
    };

    const removeRow = (index) => {
        if (formData.documents.length > 1) {
            const updatedDocuments = [...formData.documents];
            updatedDocuments.splice(index, 1);
            setFormData({ ...formData, documents: updatedDocuments });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateFormData()) return;

        try {
            const token = localStorage.getItem("authToken");
            const formDataToSend = new FormData();

            formDataToSend.append("vehicle_number", formData.vehicle_number);
            formData.documents.forEach((doc, index) => {
                formDataToSend.append(`documents[${index}][type]`, doc.type);
                formDataToSend.append(`documents[${index}][image]`, doc.image);
                formDataToSend.append(`documents[${index}][amount]`, doc.amount);
                formDataToSend.append(`documents[${index}][from_date]`, doc.from_date);
                formDataToSend.append(`documents[${index}][to_date]`, doc.to_date);
            });

            const response = await fetch(`${API_BASE_URL}updateVehicleNumber/${id}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formDataToSend,
            });

            const result = await response.json();
            if (result.status) {
                toast.success("Vehicle details updated successfully");
                navigate("/manage_vehiclenumber");
            } else {
                toast.error(result.message || "Error updating vehicle details.");
            }
        } catch (error) {
            toast.error("Failed to update vehicle details.");
        }
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed">
            <div className="wrapper">
                <Header />
                <Sidebar />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <h1>Edit Vehicle Number</h1>
                        </div>
                    </div>

                    <section className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label>Vehicle Number</label>
                                        <input
                                            type="text"
                                            name="vehicle_number"
                                            value={formData.vehicle_number}
                                            onChange={handleChange}
                                            className="form-control input-font"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Documents</label>
                                        <div className="d-flex justify-content-end">
                                            <button type="button" className="btn btn-primary" onClick={addRow}>+</button>
                                        </div>
                                        {formData.documents.map((doc, index) => (
                                            <div key={index} className="d-flex align-items-center mb-3">
                                                <select
                                                    name="type"
                                                    value={doc.type}
                                                    onChange={(e) => handleDocumentChange(index, e)}
                                                    className="form-control me-2 input-font"
                                                >
                                                    <option value="">Select Document Type</option>
                                                    <option value="Life Tax">Life Tax</option>
                                                    <option value="Insurance">Insurance</option>
                                                    <option value="Fitness Certificate">Fitness Certificate</option>
                                                    <option value="Pollution">Pollution</option>
                                                    <option value="Vehicle Challan">Vehicle Challan</option>
                                                    <option value="Incident Pic">Incident Pic</option>
                                                </select>

                                                <input
                                                    type="file"
                                                    name="image"
                                                    onChange={(e) => handleDocumentChange(index, e)}
                                                    className="form-control me-2 input-font"
                                                />

                                                {doc.image && (
                                                    <a href={typeof doc.image === "string" ? doc.image : URL.createObjectURL(doc.image)}><img
                                                        src={typeof doc.image === "string" ? doc.image : URL.createObjectURL(doc.image)}
                                                        alt="Document Preview"
                                                        style={{ width: "100px", height: "100px", objectFit: "cover", marginLeft: "10px" }}
                                                    /></a>
                                                )}

                                                {doc.type === "Vehicle Challan" && (
                                                    <>
                                                        <input
                                                            type="number"
                                                            name="amount"
                                                            placeholder="Amount"
                                                            value={doc.amount}
                                                            onChange={(e) => handleDocumentChange(index, e)}
                                                            className="form-control me-2 input-font"
                                                        />
                                                        <input
                                                            type="date"
                                                            name="from_date"
                                                            value={doc.from_date}
                                                            onChange={(e) => handleDocumentChange(index, e)}
                                                            className="form-control me-2 input-font"
                                                        />
                                                        <input
                                                            type="date"
                                                            name="to_date"
                                                            value={doc.to_date}
                                                            onChange={(e) => handleDocumentChange(index, e)}
                                                            className="form-control input-font"
                                                        />
                                                    </>
                                                )}

                                                <button type="button" className="btn btn-danger" onClick={() => removeRow(index)}>
                                                    Remove
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <button type="submit" className="btn btn-success">Submit</button>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
                <ToastContainer />
            </div>
        </div>
    );
}

export default Edit_Vehiclenumber;
